import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { PanelType } from '@types';
import Icon from '@components/Icon';
import IconTrash from '@components/icons/IconTrash';
import { $panelApi } from '@stores/panelStores';
import ImgLast from './img-last.png';
import ImgSub from './img-sub.png';
import { useCustomButtonContext } from './context';

interface Props {
  groupIndex: number;
  title: string;
  itemIndex: number;
  subMax: number;
}

function CustomButtonSubItem({ groupIndex, itemIndex, title, subMax }: Props) {
  const { onChange } = useCustomButtonContext();
  const src = itemIndex === subMax - 1 ? ImgLast : ImgSub;
  return (
    <div className="flex h-30 items-center px-10 text-base">
      <Icon className="mr-10 flex-shrink-0" src={src} />
      <div
        className="mr-10 flex-1 cursor-pointer truncate text-black-gray hover:text-white"
        onClick={() =>
          $panelApi.show({
            type: PanelType.customButton,
            groupIndex,
            buttonIndex: itemIndex,
          })
        }
      >
        {title}
      </div>
      <IconTrash
        className="flex-shrink-0"
        onClick={() => {
          onChange((draft) => {
            draft[groupIndex].children.splice(itemIndex, 1);
          });
        }}
      />
    </div>
  );
}

export default SortableElement(CustomButtonSubItem);
